import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  OnChanges,
  output,
  SimpleChanges,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { SkeletonModule } from 'primeng/skeleton';
import { DocumentResponseDto } from '@taxora-shared-common/util';
import { DocumentAuditTrail } from './document-audit-trail';

@Component({
  selector: 'lib-document-preview-drawer',
  templateUrl: './document-preview-drawer.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DrawerModule, ButtonModule, SkeletonModule, TranslatePipe, DocumentAuditTrail],
})
export class DocumentPreviewDrawer implements OnChanges {
  private readonly sanitizer = inject(DomSanitizer);

  readonly document = input<DocumentResponseDto | null>(null);
  readonly viewUrl = input<string | null>(null);
  readonly isLoadingDoc = input<boolean>(false);
  readonly isLoadingUrl = input<boolean>(false);
  readonly visible = input<boolean>(false);

  readonly close = output<void>();

  protected safeUrl: SafeResourceUrl | null = null;

  protected readonly isPdf = computed(() => {
    const mime = this.document()?.storageFile.mimeType;
    return mime === 'application/pdf';
  });

  protected readonly isImage = computed(() => {
    const mime = this.document()?.storageFile.mimeType;
    return mime?.startsWith('image/') ?? false;
  });

  protected readonly hasPreview = computed(() => this.isPdf() || this.isImage());

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['viewUrl']) {
      const url = this.viewUrl();
      this.safeUrl = url ? this.sanitizer.bypassSecurityTrustResourceUrl(url) : null;
    }
  }

  protected onClose(): void {
    this.close.emit();
  }
}
